import axios from 'axios';

export default {

  get(apiPath, params) {
    if (params) {
      return axios.get(apiPath, { params });
    } else {
      return axios.get(apiPath);
    }
  },
  createFolder(apiPath, title, description) {
    // folder: replace spaces with _ and remove all special character and only lowercase
    const folder = title.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    return axios.post(apiPath, { title, folder, description });
  },
  reorder(table, sorts) {
    return axios.put(`${table}/reorder`, { sorts });
  },
  upload(formData, id, config) {
    // config = {headers: { 'Content-Type': 'multipart/form-data' }};
    return axios.post(`photo/${id}`, formData, config);
  },
  create(apiPath, props) {
    return axios.post(apiPath, props);
  },
  update(apiPath, props) {
    return axios.put(apiPath, props);
  },
  delete(apiPath) {
    return axios.delete(apiPath);
  }
};



// WEBPACK FOOTER //
// ./src/apis/photos-api.js